export default {
      id: "quote-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#quote",
      toString: function () {
        return this.url;
      }
    }